<template>
  <v-app>
    <Splash v-if="!startView" />
    <v-row id="first" class="row-inner ma-0" light>
      <v-col cols="12" class="pa-0">
        <InsidePage v-if="insidePage === 1  && startView" />
        <InsidePage2 v-if="insidePage === 2  && startView" />
        <Home v-if="insidePage === 3  && startView" />
      </v-col>
    </v-row>
    <message />
  </v-app>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import MessageShow from "@/components/Message";
import Footer from "@/components/Footer";
import AppBar from "@/components/AppBar";
import AppBarInner from "@/components/AppBarInner";
import AppBarInner2 from "@/components/AppBarInner2";
import Home from "@/components/Home";
import InsidePage from "@/views/InsidePage";
import InsidePage2 from "@/views/InsidePage2";
import Splash from "@/components/Splash";

Vue.use(Vuex);

export default {
  name: "AppRoot",
  components: {
    message: MessageShow,
    Footer,
    AppBar,
    AppBarInner,
    Home,
    InsidePage,
    InsidePage2,
    Splash,
  },
  data() {
    return {
      startView: false,
      localLoadPathData: null,
    };
  },
  metaInfo: {
    title: "",
    titleTemplate: "%s ТРЦ Гагаринский",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },
  watch: {
    $route(out) {
      let vApp = this;
     if(vApp.isDebug)   console.log("out :", out);
     if(vApp.isDebug)   console.log("out :", out.name);
     if(vApp.isDebug)   console.log("vApp.allShops :", vApp.allShops);

      if (vApp.allShops !== null) {
       if(vApp.isDebug)   console.log("setBreadcrumb");
        //  vApp.setBreadcrumb();
      }

      switch (out.name) {
        case "Home":
          vApp.insidePage = 3;
          break;
        case "AllShops":
          vApp.insidePage = 1;
          break;
        case "AllShopsCategory":
          vApp.insidePage = 1;
          break;
        case "AllServiceCategory":
          vApp.insidePage = 1;
          break;
        case "AllCafe":
          vApp.insidePage = 1;
          break;
        case "Entertaintment":
          vApp.insidePage = 1;
          break;
        case "AllServices":
          vApp.insidePage = 1;
          break;
        case "AllNews":
          vApp.insidePage = 1;
          break;
        case "AboutTRC":
          vApp.insidePage = 1;
          break;
        case "Contacts":
          vApp.insidePage = 1;
          break;
        case "Arenda":
          vApp.insidePage = 1;
          break;
        case "Gallery":
          vApp.insidePage = 1;
          break;
        case "SinglePage":
          vApp.insidePage = 1;
          break;
          case 'Error404Page':
          vApp.insidePage = 1;
          break;

        default:
          vApp.insidePage = 2;
          break;
      }
    },
    allShops(loadShp, old) {
      let vApp = this;
     if(vApp.isDebug)   console.log("old loadShp :", old);
     if(vApp.isDebug)   console.log("loadShp :", loadShp);
    },
    isLoadAllData(loadAll, old) {
      let vApp = this;
     if(vApp.isDebug)   console.log("old loadAll :", old);
     if(vApp.isDebug)   console.log("loadAll :", loadAll);
      if (loadAll) {
        //  vApp.setBreadcrumb();
      }
    },
    async loadMenuData(loadAll, old) {
      let vApp = this;
     if(vApp.isDebug)   console.log("old loadMenuData  :", old);
     if(vApp.isDebug)   console.log("loadMenuData :", loadAll);
      if (await loadAll) {
        //  vApp.setBreadcrumb();

      if(vApp.isDebug)    console.log(
          "                                        <<<<<<<<<< vApp.loadPathData :>> ",
          loadAll
        );
        vApp.setMenu();
      }
    },
  },
  methods: {
    async setLocalLoadPathData() {
      const vApp = this;
      vApp.localLoadPathData = await vApp.loadPathData;
    },
    setMenu() {
      const vApp = this;

      vApp.menu = vApp.loadMenuData;
    if(vApp.isDebug)    console.log(
        "                    >>>>>>>>>>>>>======= vApp.menu :>> ",
        vApp.menu
      );
      vApp.menuh = vApp.loadMenuData.slice(1);
    },
    loadShopsData() {
      const vApp = this;

      axios({
        method: "get",
        url:
          "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_all_shops/json",
      })
        .catch(function (error) {
        if(vApp.isDebug)    console.log("ERROR: ", error);
        })
        .then(function (response) {
        if(vApp.isDebug)    console.log("response dataAllShops =", response.data);

          const dataStorage = localStorage.wwwgagarin;
          const dataFromSite = JSON.stringify(response.data);
          vApp.loadAllData.getAllShopsD = true;

          if (dataStorage !== dataFromSite) {
          if(vApp.isDebug)    console.log("Local NOT EQUAL Site :>> ");
            vApp.$store.dispatch("loadShops", response.data);
            vApp.startView = true;

            localStorage.wwwgagarin = JSON.stringify(response.data);
            vApp.loadAllData.getAllShopsD = true;
          }
        });
    },
    setBreadcrumb() {
      let vApp = this;
    if(vApp.isDebug)    console.log("$route.fullPath :", vApp.$route.fullPath);
      let arrCurrPath = vApp.$route.fullPath.split("/");
      if (vApp.$route.fullPath === "/") {
        arrCurrPath = [""];
      if(vApp.isDebug)    console.log("set dark theme");
        this.$store.dispatch("setTheme", true);
      } else {
      if(vApp.isDebug)    console.log("set light theme");
        this.$store.dispatch("setTheme", false);
      }

    if(vApp.isDebug)    console.log("arrCurrPath :", arrCurrPath);
    if(vApp.isDebug)    console.log("vApp.loadPathData :", vApp.loadPathData);

      if (vApp.loadPathData != null) {
        let subCat = arrCurrPath.length === 3 ? true : false;

        let items = arrCurrPath.map((itemP, itr) => {
          let nodeBrd = {
            text: "",
            disabled: true,
            href: "",
          };
          switch (itemP) {
            case "":
              nodeBrd.text = "Главная";
              nodeBrd.disabled = false;
              nodeBrd.href = "/";
              break;
            case vApp.loadPathData.mnuShopsPath:
            if(vApp.isDebug)    console.log("itr :>> ", itr);
            if(vApp.isDebug)    console.log("itemP :>> ", itemP);
            if(vApp.isDebug)    console.log("subCat :>> ", subCat);
              nodeBrd.text = "Магазины";
              nodeBrd.disabled = false;
              nodeBrd.href = !subCat
                ? ""
                : "/" + vApp.loadPathData.mnuShopsPath;
              break;
            case vApp.loadPathData.mnuCafePath:
              nodeBrd.text = "Рестораны и Кафе";
              nodeBrd.disabled = false;
              nodeBrd.href = !subCat ? "" : "/" + vApp.loadPathData.mnuCafePath;
              break;
            case vApp.loadPathData.mnuNewsPath:
              nameIdNews = vApp.allNews.find((fShp) => fShp.slug === itemP);
              nodeBrd.text = "Новости";
              nodeBrd.disabled = false;
              nodeBrd.href = !subCat ? "" : "/" + vApp.loadPathData.mnuNewsPath;
              break;
            case vApp.loadPathData.mnuEntertatmentPath:
              nodeBrd.text = "Развлечения";
              nodeBrd.disabled = false;
              nodeBrd.href = !subCat
                ? ""
                : "/" + vApp.loadPathData.mnuEntertatmentPath;
              break;
            case vApp.loadPathData.mnuServicePath:
              nodeBrd.text = "Услуги";
              nodeBrd.disabled = false;
              nodeBrd.href = !subCat
                ? ""
                : "/" + vApp.loadPathData.mnuServicePath;
              break;
            case vApp.loadPathData.mnuAboutPath:
              nodeBrd.text = "О ТРЦ";
              nodeBrd.disabled = !subCat;
              nodeBrd.href = "";
              break;
            case vApp.loadPathData.mnuGalleryPath:
              nodeBrd.text = "Фотогалерея";
              nodeBrd.disabled = false;
              nodeBrd.href = !subCat
                ? ""
                : "/" + vApp.loadPathData.mnuGalleryPath;
              break;
            case vApp.loadPathData.mnuArendaPath:
              nodeBrd.text = "Заявка  на аренду";
              nodeBrd.disabled = true;
              nodeBrd.href = "";
              break;
            case vApp.loadPathData.mnuContactsPath:
              nodeBrd.text = "Контакты";
              nodeBrd.disabled = true;
              nodeBrd.href = "";
              break;

            default:
              let nameIdShop = null;
              let nameIdNews = null;

              switch (arrCurrPath[1]) {
                case "news":
                  nameIdNews = vApp.allNews.find((fShp) => fShp.slug === itemP);
                  nodeBrd.text = nameIdNews.titleAction;
                  break;
                case "photogallery":
                  if (vApp.currentGallery !== null) {
                    nodeBrd.text = vApp.currentGallery.title;
                  }
                  break;

                default:
                if(vApp.isDebug)    console.log("default switch BRDC :", arrCurrPath);
                if(vApp.isDebug)    console.log("vApp.allShops :", vApp.allShops);
                if(vApp.isDebug)    console.log("itemP :", itemP);

                  nameIdShop = vApp.allShops.find(
                    (fShp) => fShp.slug === itemP
                  );

                if(vApp.isDebug)    console.log("nameIdShop :", nameIdShop);
                  if (typeof nameIdShop !== "undefined") {
                    nodeBrd.text = nameIdShop.nameK;
                  }

                  break;
              }
              nodeBrd.disabled = true;
              nodeBrd.href = "";
              break;
          }
          return nodeBrd;
        });
      if(vApp.isDebug)  console.log("       setBreadcrumb    items :", items);
        vApp.currBreadcrumb = items;
      }
    },
  },
  computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },
    insidePage: {
      get() {
        return this.$store.state.app.insidePage;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setInsidePage", val);
      },
    },
    loadAllData: {
      get() {
        return this.$store.state.app.loadAllData;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setLoadAllData", val);
      },
    },
    isMobile: {
      get() {
        return this.$store.state.app.isMobile;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setIsMobile", val);
      },
    },
    currBreadcrumb: {
      get() {
        return this.$store.state.breadcrumb.currBreadcrumb;
      },
      set(value) {
        this.$store.dispatch("setBreadcrumb", value);
      },
    },

    loadPathData() {
      return this.$store.getters.loadPathData;
    },
    loadMenuData() {
      return this.$store.getters.getLoadMenuData;
    },
    menu: {
      get() {
        return this.$store.state.menu;
      },
      set(value) {
        this.$store.dispatch("setMenu", value);
      },
    },
    menuh: {
      get() {
        return this.$store.state.menuh;
      },
      set(value) {
        this.$store.dispatch("setMenuHome", value);
      },
    },
    message: {
      get() {
        return this.$store.state.message;
      },
      set(value) {
        this.$store.dispatch("getMessage", value);
      },
    },
    isLoadAllData: {
      get() {
        return Object.values(this.$store.state.app.loadAllData).indexOf(
          false
        ) === -1
          ? true
          : false;
      },
    },
    allShops: {
      get() {
        return this.$store.state.shops.shops;
      },
    },
    dataAdmin: {
      get() {
        return this.$store.getters.getDataAdmin;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setDataAdmin", val);
      },
    },
    newsCategory: {
      get() {
        return this.$store.getters.getNewsCategory;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setNewsCategory", val);
      },
    },
    allNews: {
      get() {
        return this.$store.state.news.news;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("loadNews", val);
      },
    },
    currentGallery: {
      get() {
        return this.$store.state.gallery.currentGallery;
      },
    },
    currentShop: {
      get() {
        return this.$store.state.shops.currentShop;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setCurrentShop", val);
      },
    },
    allPages: {
      get() {
        return this.$store.getters.getAllPages;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("setAllPages", val);
      },
    },
    getCategories() {
      return this.$store.getters.categories;
    },
  },

  beforeMount() {
    let vApp = this;
    if(vApp.isDebug)  console.log("Before Mount App :>> ");
    vApp.setLocalLoadPathData();

  },
  mounted() {
    let vApp = this;
    /*  if(vApp.isDebug)    console.log('mounted App ', vApp)
  if(vApp.isDebug)   console.log('mounted App BreakPoint => ', vApp.$vuetify.breakpoint) */

    if (vApp.$vuetify.breakpoint.xs) {
      vApp.isMobile = true;
    }

    vApp.$nextTick(function () {




      //  vApp.$store.dispatch('setDrawer', true)
      //vApp.setLocalLoadPathData()

      /* 
axios({
  method: "get",
  url: "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_site_menu/"

})
  .catch(function(error) {
    // handle error
  if(vApp.isDebug)   console.log("ERROR: ", error);
  })
  .then( function(response) {
      // handle success
    if(vApp.isDebug)   console.log(" response dataMenu =",response.data.menu );
      let readMnu = response.data.menu;
    vApp.menu =  readMnu
    vApp.menuh= readMnu.slice(1);
     
vApp.loadPathData = {
    mnuCafePath : response.data.menu.find(jf=>jf.id === '3').url,
    mnuShopsPath : response.data.menu.find(jf=>jf.id === '1').url,
    mnuEntertatmentPath : response.data.menu.find(jf=>jf.id === '5').url,
    mnuServicePath : response.data.menu.find(jf=>jf.id === '6').url,
    mnuNewsPath : response.data.menu.find(jf=>jf.id === '7').url,
    mnuAboutPath : response.data.menu.find(jf=>jf.id === '8').url,
    mnuGalleryPath : response.data.menu.find(jf=>jf.id === '9').url,
    mnuArendaPath : response.data.menu.find(jf=>jf.id === '10').url,
    mnuContactsPath : response.data.menu.find(jf=>jf.id === '11').url,

}
vApp.loadAllData.getSiteMenu = true;
    }); */

      //if(vApp.isDebug) console.log(" *****************ROUTES App vue =",vApp.$router );

      if (vApp.dataAdmin === null) {
        axios({
          method: "get",
          url:
            "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_site_settings",
        })
          .catch(function (error) {
            // handle error
          if(vApp.isDebug)   console.log("ERROR DataAdmin: ", error);
          })
          .then(function (response) {
            // handle success
          if(vApp.isDebug)   console.log("response DataAdmin =", response.data);
            vApp.dataAdmin = response.data;
            vApp.loadAllData.getSiteSettings = true;
          });
      }
      if (vApp.newsCategory === null) {
        axios({
          method: "get",
          url:
            "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_news_categories/",
        })
          .catch(function (error) {
            // handle error
          if(vApp.isDebug)   console.log("ERROR: ", error);
          })
          .then(function (response) {
            // handle success
          if(vApp.isDebug)   console.log("response dataAllNews =", response.data);
            vApp.newsCategory = response.data;
            vApp.loadAllData.getNewsCategories = true;
          });
      }

      if (vApp.allNews === null) {
        axios({
          method: "get",
          url:
            "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_news/json?site",
        })
          .catch(function (error) {
            // handle error
          if(vApp.isDebug)   console.log("ERROR: ", error);
          })
          .then(function (response) {
            // handle success
          if(vApp.isDebug)   console.log("response dataAllNews =", response.data);
            let retFNews = response.data.map((x) => {
              return {
                actionCategories: x.actionCategories,
                bannersUrl: x.bannersUrl,
                bigBannersUrl: x.bigBannersUrl,
                dateaction:
                  x.dt_end_2 === x.dt_start_2 || x.dt_end_2 === null
                    ? x.dt_start_2
                    : x.dt_start_2 + " - " + x.dt_end_2,
                dt_end_2: x.dt_end_2,
                dt_start_2: x.dt_start_2,
                fullTextAction: x.fullTextAction,
                id: x.id,
                idShopAction: x.idShopAction,
                logoShopAction: x.logoShopAction,
                nameShopAction: x.nameShopAction,
                on_main: x.on_main,
                slug: x.slug,
                textAction: x.textAction,
                titleAction: x.titleAction,
              };
            });

            vApp.allNews = retFNews;
            //  vApp.$store.dispatch("loadNews",response.data);
            vApp.$store.dispatch("setLoadNews", true);
            vApp.loadAllData.getNews = true;
          });
      }
      if (vApp.allPages === null) {
        axios({
          method: "get",
          url:
            "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_site_pages",
        })
          .catch(function (error) {
          if(vApp.isDebug)   console.log("ERROR: ", error);
          })
          .then(function (response) {
          if(vApp.isDebug)   console.log("response dataAllShops =", response.data.pages);
            vApp.allPages = response.data.pages;
            vApp.loadAllData.getSitePages = true;
          });
      }

      if (vApp.allShops === null) {
        if (localStorage.wwwgagarin) {
          //if(vApp.isDebug)   console.log("localStorage.wwwgagarin :>> ", localStorage.wwwgagarin);
          vApp.$store.dispatch(
            "loadShops",
            JSON.parse(localStorage.wwwgagarin)
          );
          setTimeout(function () {
            vApp.startView = true;
          }, 500);

          vApp.loadShopsData();
        } else {
          vApp.loadShopsData();
          /*             axios({
                  method: "get",
                  url: "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_all_shops/json"

                })
                  .catch(function(error) {
                  if(vApp.isDebug)   console.log("ERROR: ", error);
                  })
                  .then( function(response) {
                  if(vApp.isDebug)   console.log("response dataAllShops =",response.data );
                    vApp.$store.dispatch("loadShops",response.data);
                    vApp.startView = true;
                    localStorage.wwwgagarin = JSON.stringify( response.data);

                    }); */
        }

/*         axios({
          method: "get",
          url:
            "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_categories_with_shops",
        })
          .catch(function (error) {
          if(vApp.isDebug)   console.log("ERROR: ", error);
          })
          .then(function (response) {
          if(vApp.isDebug)   console.log("response dataAll Category App = ", response.data);

            vApp.$store.dispatch("updateCategory", response.data);

            vApp.grpShop = response.data[0].category;
          //  vApp.isShopsLoad = true;
            vApp.loadAllData.getCategoriesWShop = true;
          }); */
      } else {
        vApp.startView = true;
      }
    });
  },
};
</script>

<style  scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #b2beca;
}
</style>

<style>

/* @media screen and (min-aspect-ratio: 13/9) {
  html {
    transform: rotate(-90deg);
    transform-origin: left top;
    width: 100vh;
    overflow-x: hidden;
    position: absolute;
    top: 100%;
    left: 0;
  }
  .bw-dashboard {
    height: inherit;
  }
}
@media screen and (min-width: 1292px) {
  html {
    transform: none;
    transform-origin: none;
    width: 100%;
    overflow-x: none;
    position: relative;
  }
  .bw-dashboard {
    height: 100vh;
  }
} */




html {
  overflow-y: scroll;
}
.top-card {
  border-radius: 0 !important;
}
.btn-round-border-w {
  border: 0px solid #fff;
}

.icon-mob:hover {
  animation: scale-in 0.5s;
}
.icon-url:hover {
  animation: scale-in 0.5s;
}

.bounce-enter-active {
  animation: scale-in 0.5s;
}

@keyframes scale-in {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

.v-btn.v-size--small.topmnu-btn {
  font-size: 0.6rem;
}
.topmnu-btn-off {
  color: #fff;
}

.topmnu-btn-blk:hover {
  text-decoration-line: underline;
  /*  border-bottom: 2px #000 solid; */
}
.topmnu-btn:hover {
  text-decoration-line: underline;
  /* border-bottom: 2px #fff solid; */
}
.theme--light.v-btn.v-btn--text.active {
  background-color: #bbbbbb;
  color: #000;
  border-bottom: 2px #000 solid;
}
.cursor-url {
  cursor: pointer;
}

.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: 0.8;
  position: absolute;
  width: 100%;
}

.v-dialog .dialog-map {
  background-color: #000000aa;  
  backdrop-filter: blur(5px);
}
.head-map-dialog {
  background-color: #000;
}
.shop-description {
  line-height: 1.4;
}
.min-h{
  min-height: 100vh;
}
#hrefCat a.lk{
  color: #336;
  text-decoration: underline;
}
</style>
